import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ToastMessageProps } from '../toast/toastSlice';

export interface CommentsType {
 Id: number;
 Text: string;
 UserId: string;
 Modified: string;
 Created: string;
 ReferenceId: string | null;
 Table: string;
 TableRecordId: number;
 UserFullName: string;
}

interface CommentsState {
 comments?: Array<CommentsType>;
 loading?: { [key: string]: boolean | null };
 success?: { [key: string]: boolean | null };
}

export interface GetCommentsPayload {
 table: string;
 id: number;
}

export interface AddCommentPayload {
 Text: string;
 // ReferenceId: number;
 Table: string;
 TableRecordId: number;
}

export const initialState: CommentsState = {
 comments: [],
 loading: {},
 success: {},
};

const commentsSlice = createSlice({
 name: 'comments',
 initialState,
 reducers: {
  getCommentsStart(state, action: PayloadAction<GetCommentsPayload>) {
   return {
    ...state,
    loading: { ...state.loading, getComments: true },
   };
  },
  getCommentsSuccess(state, action: PayloadAction<CommentsState>) {
   return {
    ...state,
    comments: action.payload.comments,
    success: { getComments: true },
    loading: { getComments: null },
   };
  },
  getCommentsFailure(state) {
   return {
    ...state,
    success: { ...state.success, getComments: null },
    loading: { ...state.loading, getComments: null },
   };
  },
  addCommentStart(state, action: PayloadAction<AddCommentPayload>) {
   return {
    ...state,
    loading: { ...state.loading, addComment: true },
   };
  },
  addCommentSuccess(
   state,
   action: PayloadAction<CommentsState & ToastMessageProps>,
  ) {
   return {
    ...state,
    comments: action.payload.comments,
    success: { ...state.success, addComment: true },
    loading: { ...state.loading, addComment: null },
   };
  },
  addCommentFailure(state) {
   return {
    ...state,
    success: { ...state.success, addComment: null },
    loading: { ...state.loading, addComment: null },
   };
  },
  updateCommentStart(
   state,
   action: PayloadAction<{ id: number; Text: string }>,
  ) {
   return {
    ...state,
    loading: { ...state.loading, updateComment: true },
   };
  },
  updateCommentSuccess(
   state,
   action: PayloadAction<CommentsState & ToastMessageProps>,
  ) {
   return {
    ...state,
    comments: action.payload.comments,
    success: { ...state.success, updateComment: true },
    loading: { ...state.loading, updateComment: null },
   };
  },
  updateCommentFailure(state) {
   return {
    ...state,
    success: { ...state.success, updateComment: null },
    loading: { ...state.loading, updateComment: null },
   };
  },
  deleteCommentStart(state, action: PayloadAction<{ id: number }>) {
   return {
    ...state,
    loading: { ...state.loading, deleteComment: true },
   };
  },
  deleteCommentSuccess(
   state,
   action: PayloadAction<CommentsState & ToastMessageProps>,
  ) {
   return {
    ...state,
    comments: action.payload.comments,
    success: { ...state.success, deleteComment: true },
    loading: { ...state.loading, deleteComment: null },
   };
  },
  deleteCommentFailure(state) {
   return {
    ...state,
    success: { ...state.success, deleteComment: null },
    loading: { ...state.loading, deleteComment: null },
   };
  },
 },
});
export const {
 getCommentsStart,
 getCommentsSuccess,
 getCommentsFailure,
 //
 addCommentStart,
 addCommentSuccess,
 addCommentFailure,
 //
 updateCommentStart,
 updateCommentSuccess,
 updateCommentFailure,
 //
 deleteCommentStart,
 deleteCommentSuccess,
 deleteCommentFailure,
} = commentsSlice.actions;
export default commentsSlice.reducer;
